import { get, find } from 'lodash';
import { createSelector } from '@reduxjs/toolkit';

export const getPresetByName = createSelector(
  [(state) => get(state, 'advancedSearch.presets', []), (state, presetName) => presetName],
  (presets, presetName) => find(presets, (item) => item.name === presetName),
);
export const selectCurrentSearchTab = (id) => (state) => get(state.advancedSearch, ['selectedTab', id]);
export const selectAdvancedSearchPresets = (state) => get(state, 'advancedSearch.presets');
export const selectActivePresetId = (state) => get(state, 'advancedSearch.activePresetId');
export const selectSelectedProductTypes = (state) => get(state, 'advancedSearch.selectedProductTypes', []);
